import {
  forwardRef,
  useEffect,
  useImperativeHandle,
  useRef,
  useState,
} from "react";
import { useTranslation } from "react-i18next";
import { AutoRolloverContent } from "../PreferencesComponents/SystemPreferencesComponents/AutoRolloverContent";

export const AutoRolloverContainer = forwardRef(
  ({ persistentData, show }, ref) => {
    const { t } = useTranslation(["CreateTaskModal"]);

    const autoRolloverComponentRef = useRef(null);
    const [showContainer, setShowContainer] = useState(show);

    useImperativeHandle(ref, () => ({
      setShowContainer,
      getValue: () => autoRolloverComponentRef.current?.getValue(),
    }));

    useEffect(() => {
      autoRolloverComponentRef.current?.setTaskTypeValue(showContainer);
    }, [showContainer]);

    return (
      <>
        {showContainer && (
          <div className="row et-bt-light-gray-1 et-bb-light-gray-1">
            <div className="p-4">
              <span className="fs-12">{t("Settings")}</span>
              <AutoRolloverContent
                ref={autoRolloverComponentRef}
                autoRolloverData={persistentData}
                show={true}
              />
            </div>
          </div>
        )}
      </>
    );
  }
);
